<template>
    <modal width="35" :show-modal="showModal" @close-modal="$emit('close-modal')">
      <div class="delete-modal">
        <div class="flex justify-center">
          <delete-icon />
        </div>
  
        <div class="my-6">
          <p>Are you sure you want to <span>Delete</span> ?</p>
        </div>
        <div class="button-wrapper" @click="closeModal">
          <div>
            <p class="underline cursor-pointer">No, cancel</p>
          </div>
          <div>
            <primary-button button-text="Yes, Delete" @click="deletePackage" />
          </div>
        </div>
      </div>
    </modal>
  </template>
  
  <script>
  import DeleteIcon from "@/components/3pl/Operations/Bookings/NewBooking/Modals/DeleteConsigneeModalIcon.vue";
  export default {
    components: {
      DeleteIcon,
    },
    props: {
      showModal: {
        type: Boolean,
        required: true,
        default: false,
      },
    },
    methods: {
      closeModal() {
        this.$emit("close-modal");
      },
      deletePackage(){
       this.$emit('deletePackage')
      },
      deleteItem() {
        this.$store.dispatch("saveSelectedConsigneeLocation", {
          id: null,
          email: "",
          mobile: "",
          customerType: "business",
          city: null,
          state: null,
          country: "",
          zipCode: "",
          contactName: "",
          address: "",
          sendShippingUpdates: false,
        });
        this.isDeleteModal = false;
      },
    },
  };
  </script>
  
  <style scoped>
  .delete-modal {
    text-align: center;
  }
  </style>
  